import work from './work';

const banker = {
  consume: { food: 2, water: 1 },
  resilience: { food: 2, water: 2 },
  craftsmanship: { craftsmanship: 0.8 },
  luck: { luck: 1 },
  charisma: { charisma: 1 },
  startBonus: { coins: 250 },

  work: { [work.forage]: 0.5, [work.craft]: 0.6, [work.fabricate]: 0.5 }
};

export default banker;
